module.exports = {
	"Navigation": {
		"live": "",
		"stories": ""
	},
	"Search": {
		"placeholder": "",
		"errorEmpty": "",
		"errorNotFound": ""
	},
	"IndieButton": {
		"line1": "",
		"line2": "",
		"line3": ""
	},
	"InfoBox": {
		"sonnenBatterie": "sonnenBatterie",
		"ambassadorSince": "",
		"capacity": "",
		"autonomy": "",
		"pvSize": "",
		"cta": "",
		"ctaAmbassador": "",
		"disclaimer": ""
	},
	"MasterForm": {
		"title": "",
		"personalInformation": "",
		"salutation": "",
		"male": "",
		"female": "",
		"firstname": "",
		"lastname": "",
		"email": "",
		"phone": "",
		"subject": "",
		"sonnenBatterie": "",
		"sonnenCommunity": "",
		"sonnenBotschafter": "",
		"submit": "",
		"successMessage": "",
		"errorMessage": ""
	}
};


// WEBPACK FOOTER //
// ./src/i18n/it.json